import { ArrowRight } from "lucide-react";

export const Hero = () => {
  return (
    <section id="home" className="relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24 grid lg:grid-cols-2 gap-12 items-center">
        <div className="animate-fade-up">
          <div className="mb-3 font-heading font-black tracking-tight text-2xl sm:text-3xl text-[#0F0F0F]">Make Room for Believers</div>
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] bg-[#0F0F0F] text-white px-3 py-1.5">
            <span className="w-2 h-2 rounded-full bg-[#FFC000]" /> Independent Living Program
          </span>
          <h1 className="mt-6 font-heading font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#0F0F0F]">
            A place to belong.<br />
            <span className="bg-[#FFC000] px-2 box-decoration-clone">Room to grow.</span>
          </h1>
          <p className="mt-6 text-base md:text-lg text-[#4A4A4A] leading-relaxed max-w-xl">
            Make Room for Believers provides safe, affordable housing and life skills/resources that move individuals from surviving to thriving — with a community that believes in them every step of the way.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <a href="#apply" data-testid="hero-apply-btn" className="btn-brutal group">
              Start Your Application
              <ArrowRight size={18} className="ml-2 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-4 max-w-md">
            {[["60+", "Lives Changed"], ["5", "Community Homes"], ["94%", "Move Toward Independence"]].map(([n, l]) => (
              <div key={l} className="border-l-2 border-[#FFC000] pl-3">
                <div className="font-heading font-black text-2xl md:text-3xl text-[#0F0F0F]">{n}</div>
                <div className="text-xs text-[#4A4A4A] mt-1 leading-tight">{l}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative animate-fade-up" style={{ animationDelay: "0.15s" }}>
          <div className="absolute -top-4 -left-4 w-full h-full bg-[#FFC000] border-2 border-[#0F0F0F]" />
          <img
            data-testid="hero-image"
            src="https://images.unsplash.com/photo-1601041597271-71988152f98b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxob3VzZSUyMHdyYXBhcm91bmQlMjBjb3ZlcmVkJTIwZnJvbnQlMjBwb3JjaCUyMGRheXRpbWV8ZW58MHx8fHwxNzgyOTY1NjUyfDA&ixlib=rb-4.1.0&q=85"
            alt="Middle-class home with front porch"
            className="relative w-full h-[380px] md:h-[520px] object-cover border-2 border-[#0F0F0F]"
          />
          <div className="absolute -bottom-5 left-6 bg-white border-2 border-[#0F0F0F] px-4 py-3 shadow-[4px_4px_0px_#0F0F0F]">
            <p className="font-heading font-bold text-sm text-[#0F0F0F]">"They made room for me."</p>
            <p className="text-xs text-[#4A4A4A]">— Jordan, Program Graduate</p>
          </div>
        </div>
      </div>
    </section>
  );
};
